import api from './api';

const buildQueryString = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    query.append(key, value);
  });

  const serialized = query.toString();
  return serialized ? `?${serialized}` : '';
};

export const adminAPI = {
  getStats: () => api.get('/admin/stats'),
  getOverview: (params = {}) => api.get(`/admin/overview${buildQueryString(params)}`),
  getReport: (reportName, params = {}) => api.get(`/admin/reports/${reportName}${buildQueryString(params)}`),
  exportReport: (reportName, params = {}, format = 'csv') => api.get(
    `/admin/export/${reportName}${buildQueryString({ ...params, format })}`,
    { responseType: 'blob' }
  ),
  getAllUsers: (skip = 0, limit = 50) => api.get(`/admin/users?skip=${skip}&limit=${limit}`),
  getAllTransactions: (skip = 0, limit = 100) => api.get(`/admin/transactions?skip=${skip}&limit=${limit}`),
  getWithdrawalRefs: (skip = 0, limit = 50) => api.get(`/admin/withdrawal-references?skip=${skip}&limit=${limit}`),
  verifyWithdrawalReference: (referenceCode) => api.get(`/withdrawal-references/${referenceCode}`),
  collectWithdrawalReference: (referenceCode, idempotencyKey) => api.post(
    `/withdrawal-references/${referenceCode}/collect`,
    {},
    { headers: { 'Idempotency-Key': idempotencyKey } }
  ),
  getCollectionRefs: (skip = 0, limit = 100) => api.get(`/admin/collection-references?skip=${skip}&limit=${limit}`),
  updateUserStatus: (userId, status) => api.put(`/admin/users/${userId}/status?status=${status}`),
  getPaymentSettings: () => api.get('/admin/payment-settings'),
  updatePaymentSettings: (data) => api.put('/admin/payment-settings', data),
};

export default adminAPI;
